export default __webpack_public_path__ + "static/media/shape5.a50daac5.svg";